import { render } from "./MatrizQuadranteCard.vue?vue&type=template&id=9ab51410"
import script from "./MatrizQuadranteCard.vue?vue&type=script&lang=js"
export * from "./MatrizQuadranteCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__